import { sharedCommon } from "@shared/locales/en/US";

export const common = {
  ...sharedCommon,
  HaveAcount: "Have a Fullscript account?",
  SignIn: "Sign in",
  EmailAlreadyExists: "An account with this email exists, <2>sign in to continue</2>",
  LengthValidation: "Must be at least 8 characters long",
  LengthConfirmation: "Password is 8+ characters long",
  FirstName: "First name",
  LastName: "Last name",
  FirstNameRequired: "First name is required",
  EditOnceSignedIn: "You can edit this information once you are signed in",
  LastNameRequired: "Last name is required",
  CreateMyAccount: "Create my account",
  IAmA: "I am a ...",
  Password: "Password",
  TermsOfService: "By creating your account you agree to our <2>Terms of Service</2>",
  Or: "Or",
  WeRequireType: "Required so we can tailor your experience accordingly",
  Search: "Search...",
  PasswordPrompt: "Input your password to continue",
} as const;
